<template>
  <div>
    <CompDialog :isShow="isShow" @close="isShow = false">
      <div class="content">
        <div class="tip-icon">
          <img src="../../assets/error.svg" />
        </div>
        <div class="tip-text">提交失败!</div>
        <div class="tip-detail" v-html="errorText"></div>
        <div class="btn" @click="confirm">我知道了</div>
      </div>
    </CompDialog>
  </div>
</template>

<script>
import CompDialog from '../../../../components/comp-dialog/comp-dialog.vue';

export default {

  components: {
    CompDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    routeName: {
      type: String,
      default: '',
    },
  },

  computed: {
    isShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
  },

  methods: {
    confirm() {
      this.isShow = false;
      this.$router.replace({ name: this.routeName });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 602px;
  height: 529px;
  margin: auto;
  padding: 60px 0;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
}

.tip-icon {
  width: 128px;
  height: 128px;
  margin: 0 auto;
  border-radius: 50%;
  img {
    width: 100%;
  }
}

.tip-text {
  margin-top: 40px;
  color: #383333;
  font-size: 30px;
}

.tip-detail {
  margin-top: 20px;
  color: #888585;
  font-size: 28px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 244px;
  height: 78px;
  margin: 60px auto 0;
  color: #fff;
  font-size: 30px;
  background-color: #6749ec;
  border-radius: 39px;
  &:active {
    opacity: 0.8;
  }
}
</style>
